import { motion } from 'framer-motion';

export default function SimulatorFooter() {
  return (
    <footer className="bg-gray-900 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-4">DOOHNUTS</h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Premium billboard investment opportunities in Las Vegas. Strategic locations, proven returns, and comprehensive asset management.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/en" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="/en/locations" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Locations
                </a>
              </li>
              <li>
                <a href="/en/advertise" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Advertise
                </a>
              </li>
              <li>
                <a href="/en/partnership" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Partnership
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>
                  101 Convention Center Dr.<br />
                  Suite 900<br />
                  Las Vegas, NV 89109<br />
                  United States
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>+1 (702) 477-9870</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@doohnutsinc.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 DOOHNUTS Inc. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="/en/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="/en/terms" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>
          <p className="text-gray-500 text-xs text-center mt-4">
            * Images on this site are AI-generated and do not represent partnerships or affiliations with actual facilities, companies, or organizations.
          </p>
        </div>
      </div>
    </footer>
  );
}
